"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SUPPORTED_TICKER_INTERVALS = void 0;
exports.convertLabelToTickerInterval = convertLabelToTickerInterval;
exports.convertTickerIntervalToTradingViewResolution = convertTickerIntervalToTradingViewResolution;
exports.try_TickerScroll = exports.try_TickerColumns = void 0;
// =============================================
// landing TICKER controls 7/16/18
// =============================================

var scrollSpeed = 1000 / 60; //"framerate": 60 is good. 20 was decent;
var ticker_DebugLog = false; //turns on console logs
var ticker_TickerColumns_running = false;
var ticker_TickerColumns_initialized = false;
var ticker_TickerScroll_running = false;
var timer_tickerScroll;
var falloff_generated = false;
var _try_TickerColumns = exports.try_TickerColumns = function try_TickerColumns(detail) {
  if (!document.getElementsByClassName('ticker')[0]) return;
  var firstTicker = document.getElementsByClassName('ticker')[0],
    firstTicker_childCount = firstTicker.childNodes.length,
    firstTicker_childCount_fromID = Number(firstTicker.getAttribute('id'));
  if (falloff_generated === false) {
    generate_Falloff(firstTicker);
  }
  if (ticker_DebugLog === true) {
    console.log('TICKER COLUMNS: ' + firstTicker_childCount + ' of ' + firstTicker_childCount_fromID + ' ticker parts');
  }
  if (firstTicker_childCount === firstTicker_childCount_fromID && firstTicker_childCount !== 0 && ticker_TickerColumns_running === false) {
    Ticker_Columns();
  } else {
    if (detail === 'startup' && ticker_TickerColumns_initialized === false) {
      setTimeout(function () {
        _try_TickerColumns('startup');
      }, 1000);
    }
  }
};
function Ticker_Columns() {
  //this function creates and removes...
  //...ticker "columns" that are used in the loop animation

  // if ticker-scrolling doesn't exist (if component is unmounted) then return;
  if (!document.getElementsByClassName('ticker-scrolling')[0]) return;
  ticker_TickerColumns_running = true;
  if (ticker_DebugLog === true) {
    console.log('Checking ticker columns');
  }

  //whats the width of 1 ticker?
  var tickers = document.getElementsByClassName('ticker'),
    base_ticker_width = tickers[0].offsetWidth;
  if (base_ticker_width < 0) {
    base_ticker_width = 0;
  }

  // how many tickers can fit inside the page width?
  var total_windowWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
    countNeeded_tickers = 0,
    current_ticker_Count = 0;
  countNeeded_tickers = Math.ceil(total_windowWidth / base_ticker_width) + 1;
  if (countNeeded_tickers < 0 || countNeeded_tickers == null) {
    countNeeded_tickers = 0;
  }

  //how many tickers do we currently have?
  current_ticker_Count = tickers.length;
  if (current_ticker_Count < 0 || current_ticker_Count === null) {
    current_ticker_Count = 0;
  }
  if (ticker_DebugLog === true) {
    console.log(countNeeded_tickers + ' total would fit. We have ' + current_ticker_Count + ' currently');
  }

  //account for object pooling!
  var tickerScrolling_children = document.getElementsByClassName('ticker-scrolling')[0].children;
  for (var i = 0; i < tickerScrolling_children.length; i++) {
    var ticker_container = tickerScrolling_children[i],
      ticker_container_display = window.getComputedStyle(ticker_container, null).getPropertyValue('display').toLowerCase();
    if (ticker_container_display === 'none') {
      if (ticker_DebugLog === true) {
        console.log('subtracted 1 hidden ticker from COUNT!');
      }
      current_ticker_Count -= 1;
    }
  }

  //do we need to add or subtract tickers to equal countNeeded?
  if (current_ticker_Count < countNeeded_tickers) {
    //how many more do we need?
    countNeeded_tickers -= current_ticker_Count;
    if (countNeeded_tickers > 10) {
      countNeeded_tickers = 10;
    } //in case something goes horribly wrong, clamp this

    if (ticker_DebugLog === true) {
      console.log(countNeeded_tickers + ' more block(s) needed');
    }

    //loop through amount and add...
    //...keeping track of how many are needed (for pool calculations)
    var needed = countNeeded_tickers;

    //account for object pooling!
    for (var _i = 0; _i < tickerScrolling_children.length; _i++) {
      var _ticker_container = tickerScrolling_children[_i],
        _ticker_container_display = window.getComputedStyle(_ticker_container, null).getPropertyValue('display').toLowerCase();
      if (_ticker_container_display === 'none' && needed >= 1) {
        if (ticker_DebugLog === true) {
          console.log('Used pool to Create a ticker');
        }
        _ticker_container.style.display = '';
        needed -= 1;
      }
    }

    //after the pool has been checked...
    //...loop through remaining and create fresh
    for (var _i2 = 0; _i2 < needed; _i2++) {
      if (ticker_DebugLog === true) {
        console.log('Created # ' + (_i2 + 1));
      }
      var clone = tickers[0].cloneNode(true);
      tickers[0].parentNode.appendChild(clone);
    }
  } else if (current_ticker_Count > countNeeded_tickers) {
    //how many less do we need?
    current_ticker_Count -= countNeeded_tickers;
    if (ticker_DebugLog === true) {
      console.log(current_ticker_Count + ' less block(s) needed');
    }
    for (var j = 0; j < current_ticker_Count; j++) {
      if (ticker_DebugLog === true) {
        console.log('Removed # ' + (j + 1));
      }
      //move to object pool!
      tickerScrolling_children[tickerScrolling_children.length - 1].style.display = 'none';
    }
  }
  ticker_TickerColumns_running = false;
  ticker_TickerColumns_initialized = true;
}
var _try_TickerScroll = exports.try_TickerScroll = function try_TickerScroll(detail) {
  if (!document.getElementsByClassName('ticker')[0]) return;
  var firstTicker = document.getElementsByClassName('ticker')[0],
    firstTicker_childCount = firstTicker.childNodes.length,
    firstTicker_childCount_fromID = Number(firstTicker.getAttribute('id'));
  if (ticker_DebugLog === true) {
    console.log('TICKER SCROLL: ' + firstTicker_childCount + ' of ' + firstTicker_childCount_fromID + ' ticker parts');
  }
  if (firstTicker_childCount === firstTicker_childCount_fromID && firstTicker_childCount !== 0 && ticker_TickerScroll_running === false && ticker_TickerColumns_initialized === true) {
    Ticker_Scroll();
  } else {
    if (detail === 'startup') {
      setTimeout(function () {
        _try_TickerScroll('startup');
      }, 1000);
    }
  }
};
function Ticker_Scroll() {
  //we only need to scroll through one full ticker (plus offset into the next one)

  // if ticker-scrolling doesn't exist (if component is unmounted) then return;
  if (!document.getElementsByClassName('ticker-scrolling')[0]) return;
  if (ticker_DebugLog === true) {
    console.log('Attempting ticker scroll');
  }
  ticker_TickerScroll_running = true;
  clearInterval(timer_tickerScroll);
  var tickersInner = document.getElementsByClassName('ticker-scrolling')[0],
    ticker_base = document.getElementsByClassName('ticker')[0],
    tickersInner_AMT = ticker_base.offsetWidth;
  if (ticker_DebugLog === true) {
    console.log('moving backwards -' + convert_PX_to_REM(tickersInner_AMT) + ' rem (one ticker block width)');
  }
  var matrix = window.getComputedStyle(tickersInner, null).getPropertyValue('transform'),
    translate_val = matrix.match(/-?[\d]+/g),
    scroll_translateX = 0;
  if (translate_val != null) {
    scroll_translateX = translate_val[4];
  }
  timer_tickerScroll = setInterval(scroll, scrollSpeed);
  function scroll() {
    if (scroll_translateX * -1 >= tickersInner_AMT) {
      tickersInner.style.transform = 'translateX(0rem)';
      tickersInner.style.translateX = 0;
      clearInterval(timer_tickerScroll);
      Ticker_Scroll();
    } else {
      scroll_translateX--;
      tickersInner.style.transform = 'translateX(' + convert_PX_to_REM(scroll_translateX) + 'rem)';
    }
  }
  ticker_TickerScroll_running = false;
}
function convert_PX_to_REM(x) {
  return x * 0.1;
}
function generate_Falloff(firstTicker) {
  falloff_generated = true;
  var f = document.createElement('div');
  f.innerHTML = '<div class="falloffLeft"></div><div class="falloffRight"></div>';
  f.className = 'falloff';
  firstTicker.parentNode.parentNode.prepend(f);
}
var SUPPORTED_TICKER_INTERVALS = exports.SUPPORTED_TICKER_INTERVALS = {
  '1m': 60,
  '5m': 300,
  '15m': 900,
  '30m': 1800,
  '1H': 3600,
  '2H': 7200,
  '4H': 14400,
  '6H': 21600,
  '12H': 43200,
  '1D': 86400,
  '1W': 604800,
  '4W': 2419200,
  '16W': 9676800
};

// 60, 300, 900, 1800, 3600, 7200, 14400, 21600, 43200, 86400, 604800, 2419200, 9676800, 125798400
function convertLabelToTickerInterval(i) {
  switch (i) {
    case '1':
    case '1m':
      return 60;
    case '5':
    case '5m':
      return 300;
    case '15':
    case '15m':
      return 900;
    case '30':
    case '30m':
      return 1800;
    case '60':
    case '1H':
      return 3600;
    case '120':
    case '2H':
      return 7200;
    case '240':
    case '4H':
      return 14400;
    case '360':
    case '6H':
      return 21600;
    case '720':
    case '12H':
      return 43200;
    case 'D':
    case '1D':
      return 86400;
    case 'W':
    case '1W':
      return 604800;
    case '4W':
      return 2419200;
    case 'M':
      return 2592000;
    case '16W':
      return 9676800;
    default:
      return 60;
  }
}
function convertTickerIntervalToTradingViewResolution(interval) {
  switch (interval) {
    default:
      return '15';
    case 60:
      return '1';
    case 300:
      return '5';
    case 900:
      return '15';
    case 1800:
      return '30';
    case 3600:
      return '60';
    case 7200:
      return '120';
    case 14400:
      return '240';
    case 21600:
      return '360';
    case 43200:
      return '720';
    case 86400:
      return 'D';
    case 604800:
      return 'W';
    case 2419200:
      return '4W';
    case 2592000:
      return 'M';
    case 9676800:
      return '16W';
  }
}